
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sexleketoy/fiftyshadesofgray",
      function () {
        return require("private-next-pages/sexleketoy/fiftyshadesofgray/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sexleketoy/fiftyshadesofgray"])
      });
    }
  